import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=1fd13754&scoped=true"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"
import style0 from "./ModalError.vue?vue&type=style&index=0&id=1fd13754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd13754",
  null
  
)

export default component.exports